<template>
    <div :class="['addcarte',!isMobile?'choose':'mchoose',{mobileCommon:isMobile}]">
        <div v-if="editIndex!='9999'">
            <div class="list" v-for="(item,i) in msg" :key="i">
                <div class="item" :style="!isMobile?
                    'width:'+width+'rem;height:'+height+'rem':
                    'width:'+width+'vw;height:'+height+'vw'"
                     :class="bg?' bg':'border'"
                     v-if="i!=editIndex">
                    <!-- 信息展示 -->
                    <div v-for="(value,index) in carteTitle" :key="index">
                        <div class="title" v-if="value.title">
                            <span class v-if="genre==1 && index==0">{{ langPage['v4-addcarte']['TXT_visa'] }}</span>
                            <span class v-if="genre==0">{{ value.title }}</span>
                            <p @click="edit(i,item)" v-if="index==0 && buttonVal">
                                {{ langPage['v4-confirmation']['TXT_modifier'] }}</p>
                        </div>
                        <div v-if="genre==1" class="genre1">
                            <div v-if="index<2">
                                <p v-if="index==1">{{ encryption(item[value.key]) }}</p>
                                <p v-else>{{ item[value.key] }}</p>
                            </div>
                            <div v-if="index>2" class="flex">
                                <span>{{ item[carteTitle[2].key] }}</span>
                                <span>{{ item[carteTitle[3].key] }}</span>
                            </div>
                        </div>
                        <div class="detalis" v-if="value.title&&genre!==1">{{ item[value.key] }}</div>
                    </div>
                </div>
                <div v-else :class="choose==1?'choosefrom':''">
                    <el-button class="blackBtn" @click="editIndex='no'">{{ langPage['v4-choosecarte']['TXT_annulernouvelleadresse'] }}</el-button>
                    <!-- 表单 -->
                    <el-form
                        label-position="top"
                        ref="formlist"
                        :rules="rules"
                        :model="formdata"
                        :hide-required-asterisk="true"
                    >
                        <el-form-item v-if="isShowCountry" :label="langPage['v4-entreprise']['TXT_choisissezunpays']">
                            <el-select v-model="formdata.id_pays" placeholder="">
                                <el-option
                                    v-for="item in nations"
                                    :key="item.id_pays"
                                    :label="item.texte_fr"
                                    :value="item.id_pays"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            :prop="value.key"
                            :label="value.title"
                            v-for="(value,index) in carteTitle"
                            :key="index"
                        >
                            <!-- <div>{{value}}</div> -->
                            <el-input
                                v-if="value.title"
                                :hide-required-asterisk="false"
                                :type="value.type?value.type:'text'"
                                v-model="formdata[value.key]"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="opt">
                        <button class="enregistrer" @click="deleAddress">{{
                                langPage['panierv2']['TXT_supprimer']
                            }}
                        </button>
                        <button class="enregistrer" @click="sub">{{
                                langPage['mobile-form']['TXT_enregistrer']
                            }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="editIndex==9999" :class="choose==1?'choosefrom':''">
            <el-button class="blackBtn" @click="editIndex='no'">{{ langPage['v4-choosecarte']['TXT_annulernouvelleadresse'] }}</el-button>
            <!-- 表单 -->
            <p v-if="genre==1" class="pt2">{{ langPage['v4-addcarte']['TXT_creationnouvellecarte'] }}</p>
            <el-form
                label-position="top"
                ref="formlist2"
                :rules="rules"
                :model="formdata"
                :hide-required-asterisk="true"
            >
                <el-form-item :label="langPage['v4-entreprise']['TXT_choisissezunpays']">
                    <el-select v-model="formdata.id_pays" placeholder="">
                        <el-option
                            v-for="item in nations"
                            :key="item.id_pays"
                            :label="item.texte_fr"
                            :value="item.id_pays"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    :prop="value.key"
                    :label="value.title"
                    v-for="(value,index) in carteTitle"
                    :key="index"
                    v-if="!value.onlyShow"
                >
                    <el-input v-if="value.title" :type="value.type?value.type:'text'"
                              v-model="formdata[value.key]"></el-input>
                </el-form-item>
            </el-form>
            <div class="opt" v-if="choose!=1">
                <button class="enregistrer" @click="deleAddress">{{ langPage['panierv2']['TXT_supprimer'] }}</button>
                <button class="enregistrer" @click="sub">{{ langPage['mobile-form']['TXT_enregistrer'] }}</button>
            </div>
        </div>
        <div class="addbtn" @click="addcarte" v-if="buttonVal " :class="choose==1?'choosebtn':''">
            <button class="btn"> +{{ buttonVal }}</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "addCarte",
    props: {
        // addresstype: {  //地址类型(发票订单)
        //   type: String,
        //   default:'',
        //   required:true
        // },
        msg: {
            type: Array,
            default: () => []
        },
        carteTitle: {
            type: Array,
            default: () => []
        },
        buttonVal: {
            type: String,
            default: ""
        },
        genre: {
            type: String,
            default: "0"
        },
        choose: {
            type: String,
            default: "0"
        },
        width: {
            type: String,
            default: "4.16"
        },
        bg: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
        },
        isShowCountry: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            editIndex: "no",
            formdata: {id_pays: ''},
            rules: {
                id_pays: [{required: true, message: "need choisissez un pays", trigger: "blur"}]
            },
            item: {},//当前编辑的数据
            nations: [],//国家信息
        };
    },
    mounted() {
        console.log('addCartMsg', this.msg)
        for (var i = 0; i < this.carteTitle.length; i++) {
            if (!this.carteTitle[i].onlyShow) {//只提供显示，不进行编辑修改 only show,no edit
                this.rules[this.carteTitle[i].key] = this.carteTitle[i].rule;
                if (this.carteTitle[i].key) {
                    this.$set(this.formdata, this.carteTitle[i].key, "");
                }
            }
        }
        this.fetchNations();
    },
    methods: {
        edit(i, item) {
            this.item = item;
            this.editIndex = i;
            for (var key in this.formdata) {
                this.formdata[key] = this.msg[i][key] || this.msg[i][key] == 0 ? this.msg[i][key] : ''
            }
        },

        sub(formName) {
            let th = this;
            // 新建
            if (this.editIndex == 9999) {
                this.$refs.formlist2.validate(valid => {
                    if (valid) {
                        this.$emit('submit', this.formdata, 1)
                    }
                });
            }
            // 编辑
            if (this.editIndex != 9999 && this.editIndex != "no") {
                this.$refs.formlist[0].validate(valid => {
                    if (valid) {
                        this.$emit('submit', this.formdata, 0)
                    } else {
                        console.log("error submit!!");
                    }
                });
            }
        },
        cancel() {
            this.editIndex = "no";
        },
        addcarte() {
            for (var i = 0; i < this.carteTitle.length; i++) {
                if (this.carteTitle[i].key) {
                    this.$set(this.formdata, this.carteTitle[i].key, "");
                }
            }
            this.editIndex = 9999;
        },
        encryption(str) {
            return new Array(str.length).join("*") + str.substr(-2);
        },
        //删除地址
        deleAddress() {
            let that = this;
            this.$confirm(this.langPage['v4-moncompte-adresse']['TXT_supprimerconfirm'], '', {
                confirmButtonText: this.langPage['panier-commandes-lignes']['TXT_oui'],
                cancelButtonText: this.langPage['panier-commandes-lignes']['TXT_non']
            }).then(() => {
                let data = {};
                data.id_adresse = that.msg[this.editIndex]['id_adresse'];
                data.id_acheteur = localStorage.getItem('id_acheteur');
                that.$api.info.deleAddress(data).then(res => {
                    that.$router.go(0);
                }).catch(err => {
                })
            }).catch(() => {
            })
        },
        //获取国家信息
        fetchNations() {
            this.$api.info.getNations().then(res => {
                this.nations = res;
                this.formdata.id_pays = this.nations[0].id_pays
            }).catch(err => {
                console.log(err)
            })
        }
    }
};
</script>
<style lang="less">
.addcarte {
    .el-textarea {
        textarea {
            height: 1.05rem;
            resize: none;
        }
    }
}
</style>
<style lang="less">

</style>
<style lang="less" scoped>
.choose {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .item {
        width: 4.16rem;
    }

    .bg {
        background: #DFE7F1
    }

    .list {
        line-height: 24px;
        margin-bottom: 24px;

        .item {
            margin-bottom: 10px;
            padding: 0.24rem 0.32rem;

        }

        p {
            // font-size: 14px;
            letter-spacing: 0.05em;
            text-transform: uppercase;
        }

        .genre1 {
            font-size: 0.14rem !important;
            line-height: .36rem;
        }

        .detalis {
            font-size: 14px;
            width: 3.36rem;
            line-height: 24px;
            // color: red;
        }

        .title {
            display: flex;
            justify-content: space-between;

            p:last-child {
                cursor: pointer;
            }

            span {
                font-weight: bold;
                font-family: MaisonNeue-Medium;
                font-size: 14px;
                line-height: 24px;
                margin-top: 8px;
                text-transform: uppercase;
            }

            p {
                font-weight: bold;
            }
        }
    }

    .opt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.4rem;

        div {
        }

        button {
            width: 2rem;
            height: 0.48rem;
            background: #000000;
            color: #fff;
        }
    }

    .border {
        border: 1px solid #e3e3e3;
    }

    .addbtn {
        width: 4.16rem;
        padding: 0.14rem 0;
        border: 1px solid #e3e3e3;
        text-align: center;

        .btn {
            background-color: #fff;
            border: none;
            font-weight: bold;
        }
    }

    .pt2 {
        padding-bottom: 20px;
    }

    .flex {
        display: flex;
    }

    .choosefrom {
        width: 4.16rem;
    }

    .choosebtn {
        width: 4.16rem;

        height: 0.48rem;
    }
}

.mchoose {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .item {
        width: 4.16rem;
    }

    .bg {
        background: #DFE7F1
    }

    .list {
        margin-bottom: 24px;

        .item {
            margin-bottom: 10px;
            padding: 24px 32px;

        }

        p {
            font-size: 10pt;
            line-height: 24px;
            letter-spacing: 0.05em;
            text-transform: uppercase;
        }

        .genre1 {
            font-size: 10pt !important;
        }

        .detalis {
            font-size: 10pt;
            line-height: 24px;
            // color: red;
        }

        .title {
            display: flex;
            justify-content: space-between;
            text-transform: uppercase;

            p:last-child {
                cursor: pointer;
                text-transform: uppercase;
            }

            span {
                font-weight: bold;
                font-size: 10pt;
                line-height: 24px;
                margin-top: 2vw;
                text-transform: uppercase;
            }
        }
    }

    .opt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 1vw;

        div {
        }

        button {
            background: #000000;
            color: #fff;
            padding: 2vw 3vw;
            font-size: 10pt;
        }
    }

    .border {
        border: 1px solid #e3e3e3;
    }

    .addbtn {
        width: 100%;
        padding: 2vw 0;
        border: 1px solid #e3e3e3;
        text-align: center;

        .btn {
            background-color: #fff;
            border: none;
            font-size: 10pt;
        }
    }

    .pt2 {
        padding-bottom: 20px;
    }

    .flex {
        display: flex;
    }

    .choosefrom {
        width: 4.16rem;
    }

    .choosebtn {
        width: 4.16rem;

        height: 0.48rem;
    }
}
</style>
